import { Box, Container, CssBaseline } from '@mui/material';
import { Suspense, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { AppHeader } from './AppHeader';
import { AppNavigation } from './AppNavigation';
import { ErrorBoundary } from './ErrorBoundary';
import { Loader } from './Loader';

const drawerWidth = 240;

export function AppLayout() {
	const [mobileOpen, setMobileOpen] = useState(false);

	const handleDrawerToggle = () => {
		setMobileOpen(!mobileOpen);
	};

	return (
		<Box sx={{ display: 'flex' }}>
			<CssBaseline />
			<AppHeader drawerWidth={drawerWidth} onDrawerToggle={handleDrawerToggle} />
			<AppNavigation
				drawerWidth={drawerWidth}
				mobileOpen={mobileOpen}
				onDrawerToggle={handleDrawerToggle}
			/>
			<Box
				component="main"
				sx={{
					flexGrow: 1,
					p: 1,
					mt: '74px',
					minHeight: `calc(100vh - 74px)`,
					width: {
						xs: '100%',
					},
				}}
			>
				<Container maxWidth="lg" sx={{ mt: 2 }}>
					<ErrorBoundary>
						<Suspense
							fallback={
								<Box
									display="flex"
									justifyContent="center"
									alignItems="center"
									minHeight="200px"
								>
									<Loader />
								</Box>
							}
						>
							<Outlet />
						</Suspense>
					</ErrorBoundary>
				</Container>
			</Box>
		</Box>
	);
}
